import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const ButtonStart = withStyles(theme => ({
  root: {
    textTransform: 'uppercase',
    fontSize: '1.5rem',
    padding: '6rem',
    borderRadius: '0.25rem',
    fontWeight: 600,
    letterSpacing: '0.2rem',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '&:active': {
      backgroundColor: theme.palette.primary.main,
    },
    '&:focus': {
      boxShadow: `0 0 0 0.2rem ${theme.palette.primary.main}`,
    },
  },
}))(Button);

export default ButtonStart;
